<template>
    <div class="pmContent">
        <PmLeft
            v-bind="$attrs"
            @xyPosFn="xyPosFn" :type="type" :newInfo="newInfo" />
        <PmRight
            v-bind="$attrs"
            @typeFn="typeFn" @info="info" :xy="xy" />
    </div>
</template>

<script>
import PmLeft from './pm/PmLeft-mf.vue';
import PmRight from './pm/PmRight-mf.vue';
import { PLAN_INFO_TYPE } from '@/utils/planUtil-mf'
export default {
    components: {
        PmLeft,
        PmRight
    },
    data(){
        return {
            // 选择监测点之后请求回来的数据  这里不用event bus了
            type: PLAN_INFO_TYPE.DEVICE,   // 1-设备 2-监测点
            newInfo:{},
            xy:{}
        }
    },
    methods:{
        typeFn(val) {
            this.type = val
        },
        info(obj){
            this.newInfo = obj ? {...obj} : null
        },
        xyPosFn(obj){
            this.xy = {...obj}
        }
    }
}
</script>

<style lang="scss" scoped>
.pmContent {
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
}
</style>
